import type { AxiosInstance } from 'axios'

export const imageCategories = [
  { l10nKey: 'decor', searchTerm: 'Décor' },
  { l10nKey: 'gifts', searchTerm: 'Gifts' },
  { l10nKey: 'fashion', searchTerm: 'Fashion' },
  { l10nKey: 'pets', searchTerm: 'Pet' },
  { l10nKey: 'gardening', searchTerm: 'Gardening' },
  { l10nKey: 'kidsToys', searchTerm: 'Toys kids' },
  { l10nKey: 'jewelry', searchTerm: 'Jewelry' },
  { l10nKey: 'officeEquipment', searchTerm: 'Office Equipment' },
  { l10nKey: 'craft', searchTerm: 'Craft' },
  { l10nKey: 'food', searchTerm: 'Food' },
]

const defaultImageSearchQueries = [
  'local shop',
  'small shop',
  'small business shop',
  ...imageCategories.map((category) => category.searchTerm),
]

export async function downloadUnsplashImage(api: AxiosInstance, image: UnsplashImage): Promise<File> {
  const response = await api.get('/api/v2/unsplash/download', {
    params: {
      imageId: image.id,
    },
    responseType: 'blob',
  })

  const contentType = response.headers['content-type']
  const fileExtension = contentType.split('/')[1]

  const filename = `${image.alternative_slugs.en || image.id}.${fileExtension}`

  return new File([response.data], filename, {
    type: contentType,
  })
}

export async function searchUnsplashImages(
  api: AxiosInstance,
  { query, perPage = 30, page = 1, defaultSearchQuery }: ImageSearchProps,
): Promise<UnsplashImage[]> {
  const response = await api.get('/api/v2/unsplash/search', {
    params: {
      query: defaultSearchQuery || query,
      perPage,
      page,
    },
  })

  return response.data
}

export function getRandomDefaultSearchQuery(): string {
  const randomIndex = Math.floor(Math.random() * defaultImageSearchQueries.length)
  return defaultImageSearchQueries[randomIndex]
}

export type UnsplashImage = {
  id: string
  urls: {
    small: string
    full: string
  }
  links: {
    download_location: string
  }
  alt_description: string
  alternative_slugs: {
    [key: string]: string
  }
  width: number
  height: number
}

export type ImageSearchProps = {
  query?: string
  defaultSearch?: boolean
  defaultSearchQuery?: string
  perPage?: number
  page?: number
}
